import distance from './distance';
import arqpctySoils from './soil_lookup_arqpcty.json';
import colcaSoils from './soil_lookup_colca.json';
import majesSoils from './soil_lookup_majes.json';

export default function findNearestSoil(userCoords, weatherStation) {
  let nearestSoil = '';
  let tempDistance = null;

  // use weather station to pick lookup table
  const soilFeatures =
    weatherStation === 'pampaDeMajes'
      ? majesSoils.features
      : weatherStation === 'chivay' ||
        weatherStation === 'madrigal' ||
        weatherStation === 'cabanaconde'
      ? colcaSoils.features
      : arqpctySoils.features;

  soilFeatures.forEach((soil) => {
    let dist = distance(
      userCoords.latitude,
      userCoords.longitude,
      soil.geometry.coordinates[1],
      soil.geometry.coordinates[0],
      'K'
    );

    if (tempDistance) {
      if (dist < tempDistance) {
        nearestSoil = soil.properties.lookup_value;
        tempDistance = dist;
      }
    } else {
      nearestSoil = soil.properties.lookup_value;
      tempDistance = dist;
    }
  });

  return nearestSoil;
}
